import * as xh from 'xhwebtool';
import HttpService from './request';
import { WebCollectEvent, WebCollectEYesOrNo } from './proto/proto';
import {
  checkIfNewUser,
  detectDeviceType,
  encodeProtoData,
  getBrowserInfo,
  getCurrentDomain,
  getDeviceId,
  getMobileBrowserName,
  getMobileBrowserVersion,
  getRunId,
  setRunId,
} from './utils';

class EventTracker {
  public httpService: HttpService;
  /**
   * 初始化类的新实例。
   *
   * @param {Record<string, any>} apiConfig - API配置对象。默认为 { url: 'https://datacollect.rastargame.com/v1/web/collect', params: {} }。
   * @param {Record<string, any>} data - 数据对象。默认为 {}。
   * @param {Record<string, any>} sign_key - 签名key。
   */
  constructor(
    public apiConfig: Record<string, any> = {
      url: 'https://datacollect.rastargame.com/v1/web/collect',
      params: {},
    },
    public data: Record<string, any> = {},
    public sign_key: string = '',
  ) {
    this.httpService = new HttpService();
  }
  /**
   * 推送数据到服务器。
   *
   * @param {string} event - 事件名称
   * @return {Promise<void>} 返回一个 Promise，表示推送操作是否成功
   */
  public async push(event: string): Promise<void> {
    try {
      const data = await this.getUploadData(event);
      this.upload(data);
    } catch (error) {
      console.error(error);
    }
  }
  /**
   * 设置API的配置。
   *
   * @param {Record<string, any>} apiConfig - API的配置。
   * @param {Record<string, any>} data - API的数据。
   */
  public setConfig(apiConfig: Record<string, any>, data: Record<string, any>) {
    this.apiConfig = apiConfig || this.apiConfig;
    this.data = data || this.data;
  }
  /**
   * 获取上传数据的web采集事件。
   *
   * @param {string} event - 要上传的事件
   * @return {Promise<WebCollectEvent>} web采集事件数据
   */
  public async getUploadData(event: string): Promise<WebCollectEvent> {
    const deviceId = await getDeviceId();
    return {
      siteId: '1', // 站点ID
      runId: getRunId(), // 运行ID,用设备ID，转小写
      dot: event, // 埋点事件
      deviceId, // 设备ID（设备指纹） 对应百度统计-访客标识码
      browserInfo: getBrowserInfo(), // 浏览器信息
      browserName: getMobileBrowserName(), // 浏览器名称
      browserVersion: getMobileBrowserVersion(), // 浏览器版本
      os: xh.Utils.getOs(), // 操作系统 ios/android/windows
      deviceType: detectDeviceType(), // 设备类型：pc/mobile
      visitedUrl: window.location.href, // 访问地址
      visitedDomain: getCurrentDomain(), // 受访域名
      isNew: checkIfNewUser() ? WebCollectEYesOrNo.YES : WebCollectEYesOrNo.NO, // 是否新用户
      ...this.data,
    };
  }
  /**
   * 刷新运行ID。
   *
   * @return {void}
   */
  public refreshRunId() {
    try {
      setRunId();
    } catch (error) {
      console.error(error);
    }
  }
  /**
   * 整个函数的描述。
   *
   * @param {WebCollectEvent} data - 参数的描述
   * @return {Promise<void>} 返回值的描述
   */
  public async upload(data: WebCollectEvent): Promise<void> {
    // 上传数据
    const params = {
      data: encodeProtoData(data),
      tm: `${Date.now()}`,
      ver: '1.0',
      sign: '',
      ...(this.apiConfig.params || {}),
    };
    params.sign = xh.sign.XHSign(params, this.sign_key);
    this.httpService.post(this.apiConfig.url || '', params);
  }
}

export default EventTracker;
